import { Toaster } from "sonner";

export function ToasterProvider() {
  return <Toaster position="bottom-left" />;
}
